import axios from 'axios'
import ApiResponse from "@/models/apiResponse.model.js";

const API_URL = process.env.VUE_APP_API_URL;

class WebApiService {

  async login(url, apikey, loginData) {

    return axios
      ({
        method: "post",
        url: API_URL + url,
        headers: {
          'Authorization': apikey,
          'Content-Type': 'application/json'
        },
        data: Buffer.from(JSON.stringify(loginData)).toString("base64")
      })
      .then(response => {
        return Object.assign(new ApiResponse(), response.data);
      });
  }

  async get(url, token, params) {

    return axios({
      method: 'get',
      url: API_URL + url,
      params: params,
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json'
      }
    }).then(
      response => {        
        return Object.assign(new ApiResponse(), response.data);
      }
    )
    .catch(error => {           
      return new ApiResponse(error.response.status, null, error.response.statusText);
    });
  }

  async getImage(url, token, params) {

    return axios({
      method: 'get',
      url: API_URL + url,
      params: params,
      responseType:'blob',
      headers: {
        Authorization: 'Bearer ' + token  
      }
    }).then(
      response => {  
        return  Object.assign(new ApiResponse(), response);
      }
    )
    .catch(error => {           
      return new ApiResponse(error.response.status, null, error.response.statusText);
    });
  }

  async post(url, token, data, params = null) {

    return axios({
      method: 'post',
      url: API_URL + url,
      params: params,
      data: data,
      headers: {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json'
      }
    }).then(
      response => {        
        return Object.assign(new ApiResponse(), response.data);
      }
    )
    .catch(error => {           
      return new ApiResponse(error.response.status, null, error.response.statusText);
    });
  }

}


export default new WebApiService();